import { number, object, ObjectSchema, string } from 'yup';

import { IntervalType, IntervalValue } from '@client/api';

const schema: ObjectSchema<IntervalValue> = object({
  type: string<IntervalType>().oneOf(['Month', 'Year']).required().label('IntervalType'),
  count: number().min(0).integer().required()
});

const optionalSchema = object({
  type: string<IntervalType>().oneOf(['Month', 'Year']).label('IntervalType'),
  count: number().min(0).integer().transform((value, originalValue) => 
    originalValue === '' || originalValue === null ? undefined : value
  )
});

export { schema as intervalValueSchema, optionalSchema as optionalIntervalValueSchema };
